// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";

// const Createpost = () => {
//   const [formData, setFormData] = useState({
//     title: "",
//     description: "",
//     image: null,
//     quantity: "",
//   });
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState("");
//   const navigate = useNavigate();

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//   };

//   const handleImageChange = (e) => {
//     setFormData({
//       ...formData,
//       image: e.target.files[0],
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const token = localStorage.getItem("access");
//       const formDataToSend = new FormData();

//       formDataToSend.append("title", formData.title);
//       formDataToSend.append("description", formData.description);
//       formDataToSend.append("quantity", formData.quantity);
//       if (formData.image) {
//         formDataToSend.append("image", formData.image);
//       }

//       const response = await fetch(
//         "https://ambatturindustrialestate.com/api/api/posts/add/",
//         {
//           method: "POST",
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//           body: formDataToSend,
//         }
//       );

//       if (response.ok) {
//         setMessage("Post created successfully!");
//         setTimeout(() => {
//           navigate("/post");
//         }, 1500);
//       } else {
//         const errorData = await response.json();
//         setMessage(errorData.detail || "Failed to create post.");
//       }
//     } catch (error) {
//       console.error("Error creating post:", error);
//       setMessage("An error occurred while creating the post.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="container mt-4">
//       <div className="row justify-content-center">
//         <div className="col-md-8">
//           <div className="card">
//             <div className="card-header">
//               <h4 className="card-title mb-0">Create New Post</h4>
//             </div>
//             <div className="card-body">
//               {message && (
//                 <div
//                   className={`alert ${
//                     message.includes("successfully")
//                       ? "alert-success"
//                       : "alert-danger"
//                   } alert-dismissible fade show`}
//                 >
//                   {message}
//                   <button
//                     type="button"
//                     className="btn-close"
//                     onClick={() => setMessage("")}
//                   ></button>
//                 </div>
//               )}

//               <form onSubmit={handleSubmit}>
//                 <div className="mb-3">
//                   <label htmlFor="title" className="form-label">
//                     Title *
//                   </label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     id="title"
//                     name="title"
//                     value={formData.title}
//                     onChange={handleChange}
//                     required
//                   />
//                 </div>

//                 <div className="mb-3">
//                   <label htmlFor="description" className="form-label">
//                     Description *
//                   </label>
//                   <textarea
//                     className="form-control"
//                     id="description"
//                     name="description"
//                     rows="5"
//                     value={formData.description}
//                     onChange={handleChange}
//                     required
//                   ></textarea>
//                 </div>

//                 <div className="mb-3">
//                   <label htmlFor="quantity" className="form-label">
//                     Quantity
//                   </label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     id="quantity"
//                     name="quantity"
//                     value={formData.quantity}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <div className="mb-3">
//                   <label htmlFor="image" className="form-label">
//                     Image
//                   </label>
//                   <input
//                     type="file"
//                     className="form-control"
//                     id="image"
//                     name="image"
//                     accept="image/*"
//                     onChange={handleImageChange}
//                   />
//                 </div>

//                 <div className="d-flex justify-content-between">
//                   <button
//                     type="button"
//                     className="btn btn-secondary"
//                     onClick={() => navigate("/posts")}
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     className="btn btn-primary"
//                     disabled={loading}
//                   >
//                     {loading ? "Creating..." : "Create Post"}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Createpost;

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Post.css";
const Createpost = () => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    image: null,
    quantity: "",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleImageChange = (e) => {
    setFormData({
      ...formData,
      image: e.target.files[0],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = localStorage.getItem("access");
      const formDataToSend = new FormData();

      formDataToSend.append("title", formData.title);
      formDataToSend.append("description", formData.description);
      formDataToSend.append("quantity", formData.quantity);
      if (formData.image) {
        formDataToSend.append("image", formData.image);
      }

      const response = await fetch(
        "https://ambatturindustrialestate.com/api/api/posts/add/",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formDataToSend,
        }
      );

      if (response.ok) {
        setMessage("Post created successfully!");
        setTimeout(() => {
          navigate("/post");
        }, 1500);
      } else {
        const errorData = await response.json();
        setMessage(errorData.detail || "Failed to create post.");
      }
    } catch (error) {
      console.error("Error creating post:", error);
      setMessage("An error occurred while creating the post.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="createpost-container container mt-4">
      <div className="createpost-row row justify-content-center">
        <div className="createpost-col col-md-8">
          <div className="createpost-card card">
            <div className="createpost-card-header card-header">
              <h4 className="createpost-card-title card-title mb-0">
                Create New Post
              </h4>
            </div>
            <div className="createpost-card-body card-body">
              {message && (
                <div
                  className={`createpost-alert alert ${
                    message.includes("successfully")
                      ? "alert-success"
                      : "alert-danger"
                  } alert-dismissible fade show`}
                >
                  {message}
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setMessage("")}
                  ></button>
                </div>
              )}

              <form onSubmit={handleSubmit} className="createpost-form">
                <div className="createpost-field mb-3">
                  <label
                    htmlFor="title"
                    className="createpost-label form-label"
                  >
                    Title *
                  </label>
                  <input
                    type="text"
                    className="createpost-input form-control"
                    id="title"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="createpost-field mb-3">
                  <label
                    htmlFor="description"
                    className="createpost-label form-label"
                  >
                    Description *
                  </label>
                  <textarea
                    className="createpost-textarea form-control"
                    id="description"
                    name="description"
                    rows="5"
                    value={formData.description}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <div className="createpost-field mb-3">
                  <label
                    htmlFor="quantity"
                    className="createpost-label form-label"
                  >
                    Quantity
                  </label>
                  <input
                    type="text"
                    className="createpost-input form-control"
                    id="quantity"
                    name="quantity"
                    value={formData.quantity}
                    onChange={handleChange}
                  />
                </div>

                <div className="createpost-field mb-3">
                  <label
                    htmlFor="image"
                    className="createpost-label form-label"
                  >
                    Image
                  </label>
                  <input
                    type="file"
                    className="createpost-file form-control"
                    id="image"
                    name="image"
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                </div>

                <div className="createpost-actions d-flex justify-content-between">
                  <button
                    type="button"
                    className="createpost-btn createpost-btn-secondary"
                    onClick={() => navigate("/posts")}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="createpost-btn createpost-btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Creating..." : "Create Post"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Createpost;
